<template>
    <div v-if="submitting || !session"
         class="fixed-content-width">
        <loading-container  />
    </div>
    <div class="session-detail-page detail-page-container"
         v-else>
        <div v-if="session"
             class="detail-page">
            <vue-title :title="session.Name" :brand="true"></vue-title>

            <media-container v-if="session.PrimaryMedia"
                             :media="session.PrimaryMedia"
                             :entityTypeCode="'SESSION'"
                             :entityCode="session.Code"
                             :entityName="session.Name">
            </media-container>

            <div class="detail-page-summary">
                <div class="detail-page-summary-upper">
                    <div class="detail-page-bio">
                        <h1 class="page-name">
                            <span class="live-session-label live-session-label-heading"
                                  v-if="isSessionLive">LIVE</span>
                            {{session.Name}}
                        </h1>

                        <p v-if="session.Location">
                            <span class="icomoon"></span>{{session.Location}}
                        </p>
                        <p v-if="!session.HideDateTime && localTimeZoneEqualsShowTimeZone">
                            <span class="icomoon"></span>
                            <span >{{$filters.moment(session.SessionStartDateTime, 'LLLL')}}</span>
                        </p>
                        <p v-else-if="!session.HideDateTime">
                            <span class="icomoon"></span>
                            <span>{{$filters.momentEventTz(session.SessionStartDateTime, 'LLLL z')}}</span> / <span>{{$filters.momentLocalTz(session.SessionStartDateTime, 'LT z')}}</span>
                        </p>
                        <ul class="horizontal-menu">

                            <button type="button"
                                    class="icomoon"
                                    :class="[sessionModel.CanEditFavorite ? '' : 'button-noninteractive-fill']"
                                    @click="onToggleFavorite">
                                {{sessionModel.IsFavorite ? '' : ''}}
                            </button>


                        </ul>

                    </div>
                </div>

                <p v-if="session.ContactInfo.Bio"
                   class="detail-page-bio-text"
                   v-html="biography">
                </p>

                <contact-info-list :contactInfo="session.ContactInfo.ContactInfo"                               
                                   entityType="Session"
                                   :entityCode="code">
                </contact-info-list>
                <section v-if="gatherUrl" class="gather-session-qa" aria-label="Live Q&amp;A">
                    <h2>Live Q&amp;A</h2>
                    <p><a :href="gatherUrl" target="_blank" rel="noopener noreferrer">Open Q&amp;A in a new tab</a></p>
                    <iframe :src="gatherUrl" title="Live questions and answers" loading="lazy"
                            referrerpolicy="no-referrer" style="width:100%;height:640px;border:0;"></iframe>
                </section>
            </div>
 
        </div>

        <router-view class="right-pane" 
                     :typeCode="'Session'" 
                     :code="code"></router-view>
    </div>
</template>
<script>
import Common from './common'
import Token from './authentication/token'
import * as signalR from '@microsoft/signalr'
import { gatherAudienceUrl, hasGatherEmbed } from '../../../shared/gather-embed'

import { AppState } from './appstate';

export default {
    props: ['code'],

    mixins: [
        Token,
        Common
    ],   

    watch: {
        code(to, from) {
            this.stopWebinarPresence();
            this.build();
        }
    },

    computed: {
        localTimeZoneEqualsShowTimeZone() {
            try {
                return !AppState.show.ShowTimeZone || window._userTimeZone == AppState.show.ShowTimeZone;
            } catch {
                return true;
            }
        },

        session() {
            return this.sessionModel 
                ? this.sessionModel.Session
                : null;
        },

        isSessionLive() {
            return this.session && this.session.PrimaryMedia && this.session.PrimaryMedia.MediaType == "MuxLive"
                && this.session.PrimaryMedia.Uri;
        },

        gatherUrl() {
            const url = gatherAudienceUrl(this.session && this.session.GatherRoom, process.env.VUE_APP_GATHER_URL);
            const contacts = this.session && this.session.ContactInfo && this.session.ContactInfo.ContactInfo;
            // SidebarEmbed belongs to the public player; ClientApp renders Section content.
            const embeddedSections = (contacts || []).filter(item => item.Type === 'Section' && !item.IsHidden);
            return hasGatherEmbed(embeddedSections, url) ? null : url;
        },

        iFrameSrc() {
            // session.PrimaryMedia.Uri

            if(this.session.PrimaryMedia 
                && this.session.PrimaryMedia.MediaType == 'LiveWebSource') {

                let link = this.session.PrimaryMedia.Uri;

                if(link.indexOf('{{showCode}}') != -1) {
                    link = link.replace('{{showCode}}', AppState.show.Code);
                } 

                if(link.indexOf('{{attendeeCode}}') != -1) {
                    link = link.replace('{{attendeeCode}}', AppState.attendee.Code);
                }

                if(link.indexOf('{{entityTypeCode}}') != -1) {
                    link = link.replace('{{entityTypeCode}}', 'SESSION');
                }

                if(link.indexOf('{{entityCode}}') != -1) {
                    link = link.replace('{{entityCode}}', this.code);
                }

                return link;
            }
        },

        biography() {
            return this.markdown(this.session?.ContactInfo?.Bio);
        },
    },

    async beforeRouteLeave(to, from, next) {
        this.postExitAnalytics();
        next();
    },

    methods: {
        onWebinarExitRequested() {
            this.$router.go(-1);
        },

        postExitAnalytics() {
            this.postAnalytics(
                AppState.attendee.Code,
                'SessionExit',
                this.code,
                'Session',
                AppState.show.Code);
        },

        async build() {
            this.submitting = true && !this.session;            

            try {
                let result = await this.tryGet(`/api/session/${AppState.show.Code}/${this.code}`);
                this.sessionModel = result.Result;
            } catch(Ex) {
                console.error(Ex)
            }

            this.postAnalytics(AppState.attendee.Code,'SessionDetails',this.code,'Session',AppState.show.Code);

            try {
                const routeUrl = `${process.env.VUE_APP_API_URL}/api/webinar/${AppState.show.Code}/${this.code}/viewer/signin`;

                let resultLogin = await fetch(routeUrl, {
                    mode: 'cors',
                    method: 'post',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        UserCode: AppState.attendee.Code,
                        Name: AppState.attendee.DisplayName,
                        Email: AppState.attendee.PrimaryEmail,
                        CustomData: null
                    })
                });

            } catch(ex) {
                console.error("Error on webinar login - ", ex);
            }

            await this.ensureWebinarPresenceAsync();

            this.submitting = false;
        },

        onEntityUpdated(details) {
            if(details.EntityTypeCode != "SESSION" || details.EntityCode != this.code) {
                return;
            }

            this.build();
        },        

        onReconnectedToSignalR() {
            //this.build();
        },

        onFavoritesUpdated(favorites) {
            if(!favorites) {
                this.build();
            } else {

                let favorite = favorites.find(x => x.EntityTypeCode == 'SESSION' && x.EntityCode == this.session.Code);

                if(!favorite) {
                    return;
                }

                this.sessionModel.IsFavorite = favorite.IsActive;
            }

        },

       async onToggleFavorite() {
            if(!this.sessionModel.CanEditFavorite) {
                return;
            }

            window.$bus.$emit('request-toggle-favorite', {
                Type: "SESSION",
                Code: this.sessionModel.Session.Code,
                ReadOnly: false,
                AllowEditEntity: this.sessionModel.IsPageAdmin,
                Active: !this.sessionModel.IsFavorite
            })
        },


        async ensureWebinarPresenceAsync() {
            if(!AppState.show || !AppState.show.Code || !AppState.attendee || !AppState.attendee.Code || !this.code) {
                return;
            }

            if(this.webinarPresenceSignalR) {
                return;
            }

            this.webinarPresenceStopping = false;
            this.webinarPresenceInstanceCode = this.webinarPresenceInstanceCode || this.createUniqueCode();

            try {
                let connection = new signalR.HubConnectionBuilder()
                    .withUrl(`${process.env.VUE_APP_API_URL}/hub/webinars`)
                    .withAutomaticReconnect([0, 1000, 2000, 5000, 10000])
                    .build();

                this.webinarPresenceSignalR = connection;

                connection.onreconnected(() => {
                    this.subscribeToWebinarPresenceAsync();
                });

                connection.onclose(() => {
                    if(this.webinarPresenceSignalR === connection) {
                        this.webinarPresenceSignalR = null;
                    }

                    if(this.webinarPresenceStopping || this.webinarPresenceSignalR) {
                        return;
                    }

                    this.queueWebinarPresenceReconnect();
                });

                await connection.start();
                await this.subscribeToWebinarPresenceAsync();
            } catch(ex) {
                console.error("Error connecting webinar presence.", ex);
                this.webinarPresenceSignalR = null;
                this.queueWebinarPresenceReconnect();
            }
        },

        async subscribeToWebinarPresenceAsync() {
            if(!this.webinarPresenceSignalR) {
                return;
            }

            try {
                await this.webinarPresenceSignalR.invoke(
                    'SubscribeToSession',
                    AppState.show.Code,
                    this.code,
                    AppState.attendee.Code,
                    this.webinarPresenceInstanceCode);
            } catch(ex) {
                console.error("Error subscribing to webinar presence.", ex);
            }
        },

        queueWebinarPresenceReconnect() {
            if(this.webinarPresenceReconnectTimeout) {
                clearTimeout(this.webinarPresenceReconnectTimeout);
            }

            this.webinarPresenceReconnectTimeout = setTimeout(() => {
                this.webinarPresenceReconnectTimeout = null;
                this.ensureWebinarPresenceAsync();
            }, 5000);
        },

        stopWebinarPresence() {
            this.webinarPresenceStopping = true;

            if(this.webinarPresenceReconnectTimeout) {
                clearTimeout(this.webinarPresenceReconnectTimeout);
                this.webinarPresenceReconnectTimeout = null;
            }

            let connection = this.webinarPresenceSignalR;
            this.webinarPresenceSignalR = null;
            this.webinarPresenceInstanceCode = null;

            if(connection) {
                connection.stop().catch(ex => {
                    console.error("Error stopping webinar presence.", ex);
                });
            }
        }
    },

    data() {
        return {
            checkLiveVideoTimeout: null,
            sessionModel: null,
            webinarPresenceSignalR: null,
            webinarPresenceInstanceCode: null,
            webinarPresenceReconnectTimeout: null,
            webinarPresenceStopping: false,
        }
    },

    beforeUnmount() {
        this.stopWebinarPresence();
        window.$bus.$emit('on-leave-video-page', {
            Route: `${AppState.show.Code}/session/${this.code}`
        });
        window.$bus.$off('entity-updated', this.onEntityUpdated);
        window.$bus.$off('connected-to-signalr', this.onReconnectedToSignalR);
        window.$bus.$off('favorites-updated',this.onFavoritesUpdated);
    },

    mounted() {
    },

    created: function() {
        this.build();
        window.$bus.$on('connected-to-signalr', this.onReconnectedToSignalR);
        window.$bus.$on('entity-updated', this.onEntityUpdated);
        window.$bus.$on('favorites-updated',this.onFavoritesUpdated);
    },
}
</script>
